/*
  dn-bestseller-carousel.js  -  Logik des Bestseller-Karussells (sections/bestseller-carousel.liquid)

  Stand vorher als 16 KB Inline-Skript in der Section, die Daten per Liquid
  direkt hineingeschrieben. Jetzt: Daten in einem JSON-Block je Section,
  Logik hier, geladen mit defer und vom Browser gecacht. Der Code selbst
  ist der alte; geaendert sind nur Einstieg (root statt Section-ID) und
  Datenquelle. Initialisiert jede .bs-shades[data-bs-section] einmal, auch
  wenn der Theme-Editor eine Section neu rendert (shopify:section:load).
*/
(function () {
  function init(root) {
    if (!root || root.dataset.bsInit) return;
    root.dataset.bsInit = '1';
    var sid = root.getAttribute('data-bs-section');

    /* ════════════════════════════════════════════════════════════
       SHADE DATA from metaobject: bestseller_slider

       Per-slide color fields (all optional — empty = default palette):
         text_color    → name + ghost button color
         heading_color → section heading color
         arrow_color   → prev/next arrow color
         button_bg     → primary button background + border
         button_text   → primary button text

       `product` is a product-reference field. From it we take:
         • variantId → entry.product.value.selected_or_first_available_variant.id
                       (used for AJAX add-to-cart AND bundle ?free_ids=<id>)
         (product URL is no longer used for the ghost button — it only
          adds to cart + opens the drawer, and never navigates to the PDP.)

       Trailing-comma fix: is_first flag (not forloop.last which
       references the end of the full loop, not the last matching item).
       ════════════════════════════════════════════════════════════ */
    /* Die Slide-Daten (Metaobjekt bestseller_slider) liegen als JSON im
       Dokument: <script type="application/json" id="bsData-<sid>">, Aufbau
       { po: [...], gs: [...] } - gleiche Felder wie frueher im Skript. */
    var dataEl = document.getElementById('bsData-' + sid);
    if (!dataEl) return;
    var SHADES;
    try { SHADES = JSON.parse(dataEl.textContent); } catch (err) { console.warn('[bs-shades] data', err); return; }

    /* ── DOM refs ── */
    var bgLayers  = [document.getElementById('bsBgA-'+sid), document.getElementById('bsBgB-'+sid)];
    var inner     = document.getElementById('bsInner-' +sid);
    var stage     = document.getElementById('bsStage-' +sid);
    var track     = document.getElementById('bsTrack-' +sid);
    var nameEl    = document.getElementById('bsName-'  +sid);
    var prevBtn   = document.getElementById('bsPrev-'  +sid);
    var nextBtn   = document.getElementById('bsNext-'  +sid);
    var bundleBtn = document.getElementById('bsBundle-'+sid);
    var cartBtn   = document.getElementById('bsCart-'  +sid);
    var tabs      = root.querySelectorAll('.bs-shades__tab');
    if (!track) return;

    var cat = 'po', idx = 0, els = [];
    var bgTop = 0, bgCur = '', bgCache = {};
    var curVariant = null;                    /* current slide's variant id (for cart) */
    var curSoldOut = false;                   /* current slide availability (for cart btn) */

    /* ── Default color palette (white-on-dark) ─────────────────
       Used when a metafield value is null / empty string.         */
    var DEFAULTS = {
      textColor:    '#FFFFFF',
      headingColor: '#FFFFFF',
      arrowColor:   'rgba(255,255,255,0.82)',
      btnBg:        '#FFFFFF',
      btnTxt:       '#272727',
      ghostHoverTxt:   '#272727'
    };

    /* ── Apply per-slide CSS custom properties ─────────────────
       Sets vars on .bs-shades__inner; CSS reads them via var().
       Transition is handled in CSS (.4s ease on color properties). */
    function applyColors(it) {
      var s = inner.style;
      s.setProperty('--slide-text',    it.textColor    || DEFAULTS.textColor);
      s.setProperty('--slide-heading', it.headingColor || DEFAULTS.headingColor);
      s.setProperty('--slide-arrow',   it.arrowColor   || DEFAULTS.arrowColor);
      s.setProperty('--slide-btn-bg',  it.btnBg        || DEFAULTS.btnBg);
      s.setProperty('--slide-btn-txt', it.btnTxt       || DEFAULTS.btnTxt);
      s.setProperty('--slide-ghost-hover-txt', it.ghostHoverTxt || DEFAULTS.ghostHoverTxt);
    }

    /* ── Cross-fade background ── */
    function preloadBg(url) {
      if (!url || bgCache[url]) return bgCache[url] || null;
      var im = new Image(); im.src = url; bgCache[url] = im; return im;
    }
    function setBg(url) {
      if (!url || url === bgCur) return; bgCur = url;
      var apply = function () {
        if (bgCur !== url) return;
        var cur = bgTop, next = cur ^ 1;
        bgLayers[next].style.backgroundImage = 'url("' + url + '")';
        bgLayers[next].style.opacity = '1';
        bgLayers[cur].style.opacity  = '0';
        bgTop = next;
      };
      var im = preloadBg(url);
      if (im && im.complete && im.naturalWidth) apply();
      else if (im) im.addEventListener('load', apply, { once: true });
      else apply();
    }

    /* ════════════════════════════════════════════════════════════
       ADD TO CART + OPEN DRAWER  —  Focal theme (Maestrooo)

       Per Maestrooo's docs, after an AJAX add you tell the theme to
       re-render its UI (cart count + drawer contents) by dispatching
       `cart:refresh` on document.documentElement. That refresh updates
       the UI but does NOT open the mini-cart. To open it we click the
       header cart toggle, which in Focal is bound via aria-controls to
       the cart drawer (id "cart-drawer").

       Flow:
         1. POST variant → /cart/add.js
         2. dispatch `cart:refresh` on documentElement  (fills the drawer)
         3. click the cart toggle  [aria-controls="cart-drawer"]  (opens it)
         4. fallbacks: alternate opener selectors → /cart page

       If your header uses a different opener, tell me its HTML and I'll
       pin the selector exactly.
       ════════════════════════════════════════════════════════════ */
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var busy = false;

    function ghostLoading(on) {
      if (!cartBtn) return;
      cartBtn.classList.toggle('is-loading', !!on);
      cartBtn.textContent = on ? '…' : (cartBtn.getAttribute('data-label') || cartBtn.textContent);
    }

    /* Open Focal's cart drawer via its header toggle. Returns true if a
       toggle was found & clicked; false so the caller can fall back. */
    function openFocalDrawer() {
      var opener =
           document.querySelector('[aria-controls="cart-drawer"]')
        || document.querySelector('[aria-controls="mini-cart"]')
        || document.querySelector('.header__cart-toggle, .js-cart-drawer, [data-action="open-cart"]');
      if (opener) { opener.click(); return true; }
      return false;
    }

    function addToCartAndOpen(variantId) {
      if (busy) return;
      if (!variantId) return;                 /* no variant → do nothing, never redirect to PDP */
      busy = true; ghostLoading(true);

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        /* 1) Focal: refresh cart count + drawer contents */
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        /* 2) open the drawer (next frame so refreshed contents are in place).
              If the toggle can't be found we stay put — item is already added,
              we never bounce to the product page. */
        requestAnimationFrame(function () { openFocalDrawer(); });
      })
      .catch(function (err) {
        /* add failed (e.g. sold out) — stay on page, no redirect */
        console.warn('[bs-shades] add to cart failed', err);
      })
      .finally(function () { busy = false; ghostLoading(false); });
    }

    /* ── Build item elements ── */
    function build() {
      var items = SHADES[cat];
      if (!items || !items.length) { track.innerHTML = ''; els = []; return; }
      track.innerHTML = items.map(function (it, i) {
        return '<div class="bs-shades__item" data-i="' + i + '">'
              +'<img src="'+(it.img||'')+'" alt="'+(it.n||'')+'" loading="lazy"/>'
              +'</div>';
      }).join('');
      els = Array.prototype.slice.call(track.querySelectorAll('.bs-shades__item'));
      els.forEach(function (el) {
        el.addEventListener('click', function () {
          var i = +el.dataset.i; if (i !== idx) { idx = i; layout(); }
        });
      });
    }

    /* ── Coverflow positioning ── */
    function layout() {
      var items = SHADES[cat];
      if (!items || !items.length) return;
      var n = items.length, w = stage.clientWidth, mobile = w < 560;
      var spacing = mobile ? w * 0.47 : Math.max(150, Math.min(212, w * 0.195));

      els.forEach(function (el, i) {
        var off = i - idx;
        if (off >  n / 2) off -= n;
        if (off < -n / 2) off += n;
        var a = Math.abs(off), scale, op, z;
        if (mobile) {
          if      (a===0){scale=1;   op=1;   z=50;}
          else if (a===1){scale=.80; op=1;   z=40;}
          else           {scale=.68; op=0;   z=10;}
        } else {
          if      (a===0){scale=1;   op=1;   z=50;}
          else if (a===1){scale=.80; op=.80; z=40;}
          else if (a===2){scale=.62; op=.40; z=30;}
          else if (a===3){scale=.52; op=.16; z=20;}
          else           {scale=.48; op=0;   z=10;}
        }
        el.style.transform = 'translate(-50%,-50%) translateX('+(off*spacing)+'px) scale('+scale+')';
        el.style.opacity   = String(op);
        el.style.zIndex    = String(z);
        el.classList.toggle('is-center', a === 0);
      });

      var it = items[idx]; if (!it) return;
      setBg(it.bg);
      applyColors(it);                        /* ← apply per-slide colors */
      curVariant = it.variantId || null;      /* ← track variant for cart button */
      curSoldOut = !!it.soldOut || !curVariant;/* no variant also counts as unavailable */
      if (nameEl)    nameEl.textContent = it.n         || '';
      if (bundleBtn) bundleBtn.href     = it.bundleUrl || '#';

      /* ── Ghost button: sold-out → disabled + "Ausverkauft" label ── */
      if (cartBtn && !busy) {                  /* don't clobber the loading "…" mid-add */
        if (curSoldOut) {
          cartBtn.classList.add('is-soldout');
          cartBtn.setAttribute('aria-disabled', 'true');
          cartBtn.textContent = cartBtn.getAttribute('data-soldout-label')
                             || cartBtn.getAttribute('data-label') || cartBtn.textContent;
        } else {
          cartBtn.classList.remove('is-soldout');
          cartBtn.removeAttribute('aria-disabled');
          cartBtn.textContent = cartBtn.getAttribute('data-label') || cartBtn.textContent;
        }
      }
      /* ghost button href stays = cart page (set in Liquid); never PDP */
    }

    /* ── Navigation ── */
    function go(dir) {
      var n = (SHADES[cat] || []).length; if (!n) return;
      idx = (idx + dir + n) % n; layout();
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1);  });

    /* ── Ghost button → add to cart + open drawer ── */
    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (curSoldOut) return;               /* sold out → no add */
        addToCartAndOpen(curVariant);
      });
    }

    /* ── Tab switch ── */
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.cat === cat) return;
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');
        cat = btn.dataset.cat; idx = 0; build(); layout();
      });
    });

    /* ── Swipe / drag ── */
    (function () {
      var sx=0, sy=0, active=false, decided=false, horiz=false, suppress=false;
      function start(e){var p=e.touches?e.touches[0]:e;sx=p.clientX;sy=p.clientY;active=true;decided=false;horiz=false;}
      function move(e){
        if(!active) return;
        var p=e.touches?e.touches[0]:e,dx=p.clientX-sx,dy=p.clientY-sy;
        if(!decided&&(Math.abs(dx)>6||Math.abs(dy)>6)){decided=true;horiz=Math.abs(dx)>Math.abs(dy);}
        if(decided&&horiz&&e.cancelable) e.preventDefault();
      }
      function end(e){
        if(!active) return; active=false; if(!horiz) return;
        var p=e.changedTouches?e.changedTouches[0]:e,dx=p.clientX-sx;
        if(Math.abs(dx)>10) suppress=true;
        if(Math.abs(dx)>40) go(dx<0?1:-1);
      }
      stage.addEventListener('touchstart',start,{passive:true});
      stage.addEventListener('touchmove', move, {passive:false});
      stage.addEventListener('touchend',  end);
      stage.addEventListener('mousedown', start);
      window.addEventListener('mousemove',move);
      window.addEventListener('mouseup',  end);
      stage.addEventListener('click',function(e){if(suppress){e.stopPropagation();e.preventDefault();suppress=false;}},true);
    })();

    window.addEventListener('resize', layout, { passive: true });

    function warmAll(){['po','gs'].forEach(function(k){(SHADES[k]||[]).forEach(function(it){preloadBg(it.bg);});});}
    if (window.requestIdleCallback) window.requestIdleCallback(warmAll); else window.setTimeout(warmAll, 1);

    build(); layout();
    /* nach dem vollstaendigen Laden noch einmal setzen: falls Stylesheet oder
       Schriften die Buehnenbreite nachtraeglich veraendert haben */
    window.addEventListener('load', layout, { once: true });
  }

  function initAll(scope) {
    var roots = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('.bs-shades[data-bs-section]');
    Array.prototype.forEach.call(roots, init);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
